var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 12",
  fill: "currentcolor",
  stroke: "currentColor",
  clipRule: "evenodd",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.1875 5.9375H3.6875V5.4375V3.75C3.6875 2.47284 4.72284 1.4375 6 1.4375C7.27718 1.4375 8.3125 2.47284 8.3125 3.75V5.4375V5.9375H8.8125H9C9.44873 5.9375 9.8125 6.30127 9.8125 6.75V9.75C9.8125 10.1987 9.44873 10.5625 9 10.5625H3C2.55127 10.5625 2.1875 10.1987 2.1875 9.75V6.75C2.1875 6.30127 2.55127 5.9375 3 5.9375H3.1875ZM7.6875 5.9375H8.1875V5.4375V3.75C8.1875 2.54188 7.20812 1.5625 6 1.5625C4.79188 1.5625 3.8125 2.54188 3.8125 3.75V5.4375V5.9375H4.3125H7.6875Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockFilled);
export default ForwardRef;